import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'data-table-filter',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      marginBottom: theme.spacing(3),
    },
  }),
  options
);

export default useStyles;
